export default {api:{email:'nexus@korfitz.com',password:':~XsVCbi^R9JHfmH~.&?0=TM'}};